// The chip in the Create Lead popup's header: who the form is for so far (CU-869fmc59c).
// "Ann Lee — 07700 900123", or just the number when the caller has no name yet (no leading dash).
// Display only: the phone is shown the way staff say it, the saved value is untouched.
import { formatUkPhone } from './ukPhone';

export function createLeadChipText(personalDetail) {
    const pd = personalDetail || {};
    const name = [pd.first_name, pd.last_name].map((v) => (typeof v === 'string' ? v.trim() : '')).filter(Boolean).join(' ');
    const phone = pd.lead_contact?.phone;
    const contact = phone ? formatUkPhone(phone) : (pd.lead_contact?.email || '');
    return [name, contact].filter(Boolean).join(' — ');
}

export default createLeadChipText;
